
















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class PaperClip extends Vue {
  @Prop({ default: '13' }) readonly width?: string;
  @Prop({ default: '12' }) readonly height?: string;
  @Prop({ default: '#405F7A' }) readonly fill?: string;
}
